import { render, staticRenderFns } from "./DisableAccessNotification.vue?vue&type=template&id=478baffe&scoped=true&"
import script from "./DisableAccessNotification.vue?vue&type=script&lang=js&"
export * from "./DisableAccessNotification.vue?vue&type=script&lang=js&"
import style0 from "./DisableAccessNotification.vue?vue&type=style&index=0&id=478baffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478baffe",
  null
  
)

export default component.exports